<template>
  <div>
    <div class="answer-sheet">
      <div class="answer-sheet-header">
        <p class="title">答题卡</p>
        <div class="color-list">
          <div class="color-list-item">
            <i class="dot dot--correct"></i>
            <span class="text">答对</span>
          </div>
          <div class="color-list-item">
            <i class="dot dot--error"></i>
            <span class="text">答错</span>
          </div>
          <div class="color-list-item">
            <i class="dot"></i>
            <span class="text">未答</span>
          </div>
        </div>
      </div>
      <div class="answer-sheet-content">
        <div class="sheet-group" v-for="(item, index) in answer" :key="index">
          <div class="sheet-group-title">第{{ index + 1 }}组 共{{ item.list.length }}题</div>
          <ul class="sheet-group-list">
            <li v-for="(citem, cindex) in item.list" :key="cindex">
              <p class="sheet-item" :class="sheetItemClass(citem.r)">{{ citem.countIndex }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    answer: Array,
  },
  computed: {
    sheetItemClass() {
      return function (r) {
        if (r === 1) {
          return 'sheet-item--correct'
        }
        if (r === 2) {
          return 'sheet-item--error'
        }
      }
    },
  },
  data() {
    return {}
  },
}
</script>
<style lang="scss" scoped>
.answer-sheet {
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      flex: 1;
      font-size: 0.43rem;
      font-weight: 500;
      line-height: 1;
      color: #22242e;
    }

    .color-list {
      display: flex;
      align-items: center;

      &-item {
        margin-left: 0.37rem;
        white-space: nowrap;

        .dot {
          display: inline-block;
          margin-right: 0.08rem;
          width: 0.16rem;
          height: 0.16rem;
          background: #c2c5cc;
          border-radius: 50%;
          transform: translateY(-0.05rem);

          &--correct {
            background: #13bf80;
          }

          &--error {
            background: #ff6a4d;
          }
        }

        .text {
          font-size: 0.32rem;
          font-family: PingFangSC;
          font-weight: 400;
          line-height: 0rem;
          color: #919499;
        }
      }
    }
  }

  &-content {
    .sheet-group {
      margin-top: 0.64rem;

      &-title {
        font-size: 0.37rem;
        line-height: 1;
        color: #3c3d42;
        margin-bottom: 0.43rem;
      }

      &-list {
        @include grid-ul(5, 0.53rem);

        li {
          &:nth-child(n + 6) {
            margin-top: 0.53rem;
          }
        }

        .sheet-item {
          @include flex_center;
          width: 1.17rem;
          height: 1.17rem;
          background: rgba($color: #919499, $alpha: 0.05);
          border-radius: 0.21rem;
          font-size: 0.45rem;
          font-family: DIN;
          font-weight: 500;
          color: #919499;

          &--correct {
            background: rgba($color: #13bf80, $alpha: 0.05);
            color: #13bf80;
          }

          &--error {
            background: rgba($color: #ff6a4d, $alpha: 0.05);
            color: #ff6a4d;
          }
        }
      }
    }
  }
}
</style>
